import { Button, Typography, styled } from "@mui/material"
import type { AssetGroup } from "@phc/common/gen/preferencesGen"

import type React from "react"
import { useCallback } from "react"
import { extraColors } from "../../../utils/theme"
import { useRemoveAssetGroup } from "../hooks/useAssetService"
import type { GroupWithLabel } from "./AssetGroupAutocomplete"
import { DialogStyled } from "./Shared"

const GroupName = styled("span")({
  fontWeight: 600,
})

const ButtonContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  paddingTop: 10,
})

export const GroupDeleteDialog: React.FC<{
  groupToDelete: GroupWithLabel
  setGroupToDelete: React.Dispatch<
    React.SetStateAction<GroupWithLabel | undefined>
  >
  setGroups: React.Dispatch<React.SetStateAction<AssetGroup[] | undefined>>
}> = ({ groupToDelete, setGroups, setGroupToDelete }) => {
  const { mutateAsync: removeGroup, isSuccess } = useRemoveAssetGroup({
    hideToast: false,
  })

  const onDeleteGroup = useCallback(
    async (asset_group_id: string) => {
      await removeGroup({
        asset_group_id,
      })

      if (isSuccess) {
        setGroups(prev =>
          prev?.filter(g => g.asset_group_id !== asset_group_id)
        )
      }
    },
    [isSuccess, removeGroup, setGroups]
  )

  return (
    <DialogStyled
      open
      onClose={() => setGroupToDelete(undefined)}
      sx={{
        ".MuiPaper-root": {
          display: "grid",
          gap: "20px",
        },
      }}
    >
      <Typography sx={{ alignContent: "baseline" }}>
        <GroupName>Warning:</GroupName> Deleting{" "}
        <GroupName sx={{ color: extraColors.status.navy }}>
          {groupToDelete.label}
        </GroupName>{" "}
        will remove it from this and all other assets.
      </Typography>
      <ButtonContainer>
        <Button variant="outlined" onClick={() => setGroupToDelete(undefined)}>
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={() => {
            if (groupToDelete.group.asset_group_id) {
              void onDeleteGroup(groupToDelete.group.asset_group_id)
            }
            setGroupToDelete(undefined)
          }}
        >
          Delete Group
        </Button>
      </ButtonContainer>
    </DialogStyled>
  )
}
